export default "__VITE_ASSET__pX6aMxLBX$PROv7I4jKTGw__"